import { Button } from '@/_shared/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/_shared/components/ui/empty';

import slackIconUrl from '../../icons/slack.svg';

interface SlackConnectPromptProps {
  isAdmin: boolean;
  workspaceId: string;
}

export function SlackConnectPrompt({ isAdmin, workspaceId }: SlackConnectPromptProps): React.ReactElement {
  return (
    <Empty className="border">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <img src={slackIconUrl} alt="" aria-hidden className="size-6" />
        </EmptyMedia>
        <EmptyTitle>Connect Slack</EmptyTitle>
        <EmptyDescription>
          Install the Lookout Slack app to ask about your data right from your channels.
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        {isAdmin ? (
          <Button asChild variant="primary" className="shrink-0">
            <a href={`/slack/install?workspace_id=${encodeURIComponent(workspaceId)}`}>Connect</a>
          </Button>
        ) : (
          <p className="text-xs text-muted-foreground">Ask a workspace admin to connect Slack.</p>
        )}
      </EmptyContent>
    </Empty>
  );
}
